import React from 'react';
import { useNeedsReviewInvoiceServiceLinkCount } from '../../hooks/collections/useLinkReviewQueue';

/**
 * Red count pill for the "Link Review" nav entry (#3464).
 *
 * Its own component on purpose: the count query only runs while a menu that SHOWS it is open, so
 * Navigation itself (rendered on every page of every module) never reads Firestore for this.
 * The number is the server count (getCountFromServer), so it equals the queue, not a capped page.
 * No number is shown while loading or on error: a missing badge is honest, a wrong one is not.
 */
export function LinkReviewNavBadge() {
  const { data } = useNeedsReviewInvoiceServiceLinkCount();
  if (data == null || data <= 0) return null;
  return (
    <span
      aria-label={`${data} links waiting for review`}
      className="ml-2 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold leading-none text-white bg-red-500 rounded-full"
    >
      {data > 99 ? '99+' : data}
    </span>
  );
}
